function initTouchStory() {
  document.querySelector('.ts-header')?.closest('.shopify-section')?.classList.add('ts-header-section-sticky');

  const themeToggle = document.querySelector('[data-theme-toggle]');
  const syncThemeToggle = () => {
    if (!themeToggle) return;
    const isDark = document.documentElement.dataset.theme === 'dark';
    themeToggle.setAttribute('aria-pressed', String(isDark));
    themeToggle.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
  };
  syncThemeToggle();
  themeToggle?.addEventListener('click', () => {
    const isDark = document.documentElement.dataset.theme === 'dark';
    if (isDark) delete document.documentElement.dataset.theme;
    else document.documentElement.dataset.theme = 'dark';
    try { localStorage.setItem('touch-story-theme', isDark ? 'light' : 'dark'); } catch (error) {}
    syncThemeToggle();
  });

  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const closeMobileMenu = () => {
    if (!mobileMenuToggle || !mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenuToggle.setAttribute('aria-expanded', 'false');
    mobileMenuToggle.setAttribute('aria-label', 'Open menu');
  };
  mobileMenuToggle?.addEventListener('click', (event) => {
    event.stopPropagation();
    const willOpen = !mobileMenu?.classList.contains('is-open');
    mobileMenu?.classList.toggle('is-open', willOpen);
    mobileMenuToggle.setAttribute('aria-expanded', String(willOpen));
    mobileMenuToggle.setAttribute('aria-label', willOpen ? 'Close menu' : 'Open menu');
  });
  document.addEventListener('click', (event) => {
    if (mobileMenu?.classList.contains('is-open') && !event.target.closest('.ts-header')) closeMobileMenu();
  });

  const drawerShell = document.querySelector('[data-cart-drawer-shell]');
  const openCartDrawer = () => {
    if (!drawerShell) return;
    drawerShell.hidden = false;
    document.body.classList.add('ts-cart-drawer-is-open');
    window.requestAnimationFrame(() => drawerShell.classList.add('is-open'));
  };
  const closeCartDrawer = () => {
    if (!drawerShell) return;
    drawerShell.classList.remove('is-open');
    document.body.classList.remove('ts-cart-drawer-is-open');
    window.setTimeout(() => { drawerShell.hidden = true; }, 260);
  };

  document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      if (!drawerShell) return;
      event.preventDefault();
      openCartDrawer();
    });
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-drawer-close]')) closeCartDrawer();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeCartDrawer();
      closeMobileMenu();
    }
  });

  if (new URLSearchParams(window.location.search).get('cart_open') === '1') {
    openCartDrawer();
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('cart_open');
    window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-drawer-quantity-minus], [data-drawer-quantity-plus]');
    if (!button) return;
    const input = button.closest('.ts-cart-drawer-quantity')?.querySelector('input');
    if (!input) return;
    const current = Number(input.value || 0);
    input.value = button.hasAttribute('data-drawer-quantity-plus') ? current + 1 : Math.max(0, current - 1);
  });

  document.addEventListener('click', async (event) => {
    const removeLink = event.target.closest('[data-cart-remove]');
    if (!removeLink) return;
    event.preventDefault();
    if (removeLink.getAttribute('aria-busy') === 'true') return;

    const line = Number(removeLink.dataset.cartLine);
    if (!line) return;
    const originalText = removeLink.textContent;
    removeLink.setAttribute('aria-busy', 'true');
    removeLink.textContent = 'Removing…';

    try {
      const rootUrl = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootUrl}cart/change.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ line, quantity: 0 })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to remove this item.');

      document.querySelectorAll('.ts-header__bag-count').forEach((count) => {
        count.textContent = result.item_count;
      });

      const nextUrl = new URL(window.location.href);
      if (removeLink.closest('[data-cart-drawer-shell]')) nextUrl.searchParams.set('cart_open', '1');
      window.location.assign(nextUrl.toString());
    } catch (error) {
      removeLink.textContent = 'Try again';
      removeLink.removeAttribute('aria-busy');
      removeLink.setAttribute('title', error.message || 'Unable to remove this item.');
      window.setTimeout(() => {
        removeLink.textContent = originalText;
        removeLink.removeAttribute('title');
      }, 3000);
    }
  });

  document.querySelectorAll('[data-swatch]').forEach((swatch) => {
    swatch.addEventListener('click', () => {
      const selector = swatch.closest('[data-scent-selector]');
      selector?.querySelectorAll('[data-swatch]').forEach((item) => item.classList.remove('is-active'));
      swatch.classList.add('is-active');
      const label = selector?.querySelector('[data-scent-label]');
      if (label) label.textContent = swatch.dataset.swatch;
    });
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const count = button.closest('[data-quantity]')?.querySelector('[data-quantity-value]');
    if (!count) return;
    event.preventDefault();
    const current = Number(count.value || 1);
    count.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const image = gallery.querySelector('[data-product-image]');
    const zoomImage = document.querySelector('[data-product-zoom-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
    const showProductImage = (thumb) => {
      if (!image || !thumb?.dataset.imageSrc) return;
      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      image.style.opacity = '0';
      window.setTimeout(() => {
        image.src = thumb.dataset.imageSrc;
        if (zoomImage) zoomImage.src = thumb.dataset.imageSrc.replace(/width=\d+/, 'width=2400');
        image.style.opacity = '1';
      }, 160);
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showProductImage(thumb)));

    const swipeArea = gallery.querySelector('.ts-product-main-media');
    let touchStartX = 0;
    let touchStartY = 0;
    swipeArea?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });
    swipeArea?.addEventListener('touchend', (event) => {
      if (thumbs.length < 2) return;
      const distanceX = event.changedTouches[0].clientX - touchStartX;
      const distanceY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
      const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      const nextIndex = distanceX < 0
        ? (activeIndex + 1) % thumbs.length
        : (activeIndex - 1 + thumbs.length) % thumbs.length;
      showProductImage(thumbs[nextIndex]);
    }, { passive: true });
  });

  const zoomShell = document.querySelector('[data-product-zoom]');
  const zoomImage = document.querySelector('[data-product-zoom-image]');
  const openProductZoom = () => {
    if (!zoomShell) return;
    zoomShell.hidden = false;
    document.body.classList.add('ts-product-zoom-is-open');
    window.requestAnimationFrame(() => zoomShell.classList.add('is-open'));
  };
  const closeProductZoom = () => {
    if (!zoomShell) return;
    zoomShell.classList.remove('is-open');
    zoomImage?.classList.remove('is-magnified');
    document.body.classList.remove('ts-product-zoom-is-open');
    window.setTimeout(() => { zoomShell.hidden = true; }, 220);
  };
  document.querySelector('[data-product-zoom-open]')?.addEventListener('click', openProductZoom);
  document.querySelectorAll('[data-product-zoom-close]').forEach((button) => button.addEventListener('click', closeProductZoom));
  zoomImage?.addEventListener('click', () => zoomImage.classList.toggle('is-magnified'));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && zoomShell && !zoomShell.hidden) closeProductZoom(); });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const productForm = root.querySelector('.ts-product-form');
    const productMessage = root.querySelector('[data-product-message]');
    const productAddButton = root.querySelector('[data-product-add]');
    const productQuantity = root.querySelector('[data-quantity-value]');
    let productMessageTimer;

    const syncBundleSelection = () => {
      if (!productQuantity) return;
      const quantity = Math.max(1, parseInt(productQuantity.value, 10) || 1);
      root.querySelectorAll('[data-bundle-quantity]').forEach((input) => {
        const selected = Number(input.dataset.bundleQuantity) === quantity;
        input.checked = selected;
        input.closest('label')?.classList.toggle('is-selected', selected);
      });
    };

    root.querySelectorAll('[data-bundle-quantity]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked || !productQuantity) return;
        productQuantity.value = input.dataset.bundleQuantity || '1';
        syncBundleSelection();
      });
    });
    productQuantity?.addEventListener('change', syncBundleSelection);
    root.querySelector('[data-quantity]')?.addEventListener('click', () => window.setTimeout(syncBundleSelection, 0));

    const showProductMessage = (message, type) => {
      if (!productMessage) return;
      window.clearTimeout(productMessageTimer);
      productMessage.textContent = message;
      productMessage.className = `ts-product-message is-${type}`;
      productMessage.hidden = false;
      productMessageTimer = window.setTimeout(() => {
        productMessage.hidden = true;
      }, 5000);
    };

    productForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!productAddButton || productAddButton.disabled) return;

      const originalButtonHtml = productAddButton.innerHTML;
      productAddButton.disabled = true;
      productAddButton.classList.add('is-loading');
      productAddButton.textContent = 'Adding…';

      try {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(productForm)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this item.');

        try {
          const cartResponse = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          document.querySelectorAll('.ts-header__bag-count').forEach((count) => {
            count.textContent = cart.item_count;
          });
          document.querySelectorAll('[data-cart-drawer-open]').forEach((link) => {
            link.setAttribute('aria-label', `Shopping bag, ${cart.item_count} items`);
          });
        } catch (cartError) {
          // The item was added successfully; the count can update with the next cart render.
        }

        try {
          const sectionResponse = await fetch(`${rootUrl}?section_id=header`, { headers: { Accept: 'text/html' } });
          if (!sectionResponse.ok) throw new Error('Unable to refresh cart drawer.');
          const sectionHtml = await sectionResponse.text();
          const sectionDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const freshDrawer = sectionDocument.querySelector('[data-cart-drawer-shell]');
          if (drawerShell && freshDrawer) drawerShell.innerHTML = freshDrawer.innerHTML;
        } catch (drawerError) {
          // Keep the successful add state even if Shopify's optional section refresh is unavailable.
        }

        productAddButton.textContent = 'Added ✓';
        productAddButton.classList.add('is-added');
        showProductMessage('Successfully added to your cart.', 'success');
      } catch (error) {
        productAddButton.innerHTML = originalButtonHtml;
        showProductMessage(error.message || 'Unable to add this item. Please try again.', 'error');
      } finally {
        productAddButton.classList.remove('is-loading');
        window.setTimeout(() => {
          productAddButton.innerHTML = originalButtonHtml;
          productAddButton.classList.remove('is-added');
          productAddButton.disabled = false;
        }, 1800);
      }
    });

    root.querySelectorAll('[data-variant-input]').forEach((input) => {
      input.addEventListener('change', () => {
        root.querySelectorAll('.ts-product-variant').forEach((item) => item.classList.remove('is-selected'));
        input.closest('.ts-product-variant')?.classList.add('is-selected');

        const price = root.querySelector('[data-product-price]');
        const compare = root.querySelector('[data-product-compare]');
        const saving = root.querySelector('[data-product-save]');
        const buttonPrice = root.querySelector('[data-button-price]');
        const addButton = root.querySelector('[data-product-add]');

        if (price) price.textContent = input.dataset.price || '';
        if (buttonPrice) buttonPrice.textContent = input.dataset.price || '';
        if (compare) {
          compare.textContent = input.dataset.compare || '';
          compare.hidden = !input.dataset.compare;
        }
        if (saving) {
          saving.textContent = input.dataset.saving ? `Save ${input.dataset.saving}` : '';
          saving.hidden = !input.dataset.saving;
        }
        if (addButton) addButton.disabled = input.dataset.available !== 'true';
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTouchStory);
} else {
  initTouchStory();
}
